// src/data/quizQuestions.js

// Formation type mapping used for scoring keys (matches backend ScoreTypes fields)
const FORMATION_KEYS = {
    "Licence (L1)": "l1",
    "Grande ecole post bac": "grande_ecole_post_bac",
    "BUT": "but",
    "BTS": "bts",
    "CPGE": "cpge",
    "DEUST": "deust",
    "CS": "cs",
    "C.M.I": "cmi",
    "CUPGE": "cupge",
    "Formations preparatoires a l'enseignement superieur": "formations_preparatoires"
};
  
const quizQuestions = [
        {
            "id": 1,
            "text": "Pour apprendre quelque chose de nouveau, tu as tendance à préférer :",
            "category":"Apprentissage",
            "answers": [
                "D'abord bien comprendre le *pourquoi* et les idées générales avant de passer à la pratique.",
                "Apprendre *en faisant*, manipuler, essayer des choses concrètes pour voir comment ça marche.",
            ],
            "scoring": [
                {"l1": 1, "cpge": 1, "cmi": 1, "cupge": 1, "grande_ecole_post_bac": 1, "but": -1, "bts": -1, "deust": -1, "cs": -1},
                {"bts": 1, "deust": 1, "cs": 1, "but": 1, "grande_ecole_post_bac": -1, "l1": -1, "cpge": -1, "cmi": -1, "cupge": -1}
            ],
            "words_pos":["Théorie d'abord", "Pratique d'abord"],
            "words_neg":["Pas de théorie d'abord", "Pas de pratique d'abord"]
        },
        {
            "id": 2,
            "text": "Pour bien travailler, tu as plutôt besoin :",
            "category":"Organisation",
            "answers": [
                "D'un cadre clair : un emploi du temps fixe, des profs qui te suivent de près, un peu comme au lycée.",
                "De liberté pour t'organiser : pouvoir gérer ton emploi du temps et ton travail personnel, même si ça demande plus d'autonomie.",
            ],
            "scoring": [
                {"bts": 2, "cpge": 2, "deust": 2, "formations_preparatoires": 0, "but": 1, "grande_ecole_post_bac": 1, "l1": -2, "cmi": -2, "cupge": 1},
                {"l1": 2, "cmi": 2, "cupge": 2, "but": 1, "grande_ecole_post_bac": 0, "deust": -1, "bts": -2, "cpge": -2}
            ],
            "words_pos":["Cadre structuré", "Liberté / Autonomie"],
            "words_neg":["Pas de cadre structuré", "Pas de liberté / autonomie"]
        },
        {
            "id": 3,
            "text": "Tu imagines mieux tes cours se passer :",
            "category": "Environnement académique",
            "answers": [
                "Dans une petite classe où le prof peut t'aider individuellement mais où tu es obligé de suivre le cours assidûment.",
                "Dans des cours avec beaucoup d'étudiants (cours magistraux) où le prof ne peut pas t'aider individuellement mais avec plus d'autonomie.",
                "Tant que il y a un bon équilibre entre les cours magistraux et les petits groupes de travail ça me va.",
            ],
            "scoring": [
                {"bts": 2, "deust": 2, "cpge": 2, "cs": 1, "formations_preparatoires": 1, "but": -1, "grande_ecole_post_bac": 2, "l1": -2, "cmi": -2, "cupge": 2},
                {"l1": 2, "but": 2, "cmi": 1, "cupge": -1, "grande_ecole_post_bac": -1, "deust": 0, "bts": -2, "cpge": -2},
                {"bts": 0, "deust": 0, "cpge": -1, "cs": 1, "formations_preparatoires": 1, "but": 1, "grande_ecole_post_bac": 2, "l1": 1, "cmi": 1, "cupge": 0},
            ],
            "words_pos":["Petite classe", "Cours en amphithéâtre", "Petite classe et cours en amphithéâtre équilibrés"],
            "words_neg":["Pas de petite classe", "Pas de cours en amphithéâtre", "Pas d'équilibre entre CM et TD"]
        },
        {
            "id": 4,
            "text": "En termes d'évaluation, qu'est-ce qui te correspondrait le mieux ?",
            "category": "Évaluation",
            "answers": [
                "Des contrôles très réguliers avec des passages au tableau pour vérifier que tu suis bien.",
                "Des évaluations basées sur des projets concrets, des réalisations pratiques ou des stages en entreprise.",
                "Des examens importants à la fin de chaque semestre pour valider tes connaissances sur une période plus longue."
            ],
            "scoring": [
                {"cpge": 2, "cupge": 2, "bts": 1, "but": 0, "grande_ecole_post_bac": 1.5, "deust": 0, "l1": -1},
                {"but": 2, "bts": 1, "deust": 2, "cs": 3, "grande_ecole_post_bac": 1, "cmi": 0, "cpge": -2},
                {"l1": 2, "cmi": 1, "but": 1, "grande_ecole_post_bac": 1, "deust": 1, "bts": 0, "cpge": -1}
            ],
            "words_pos":["Examen par contrôle continu", "Examen par projets pratiques ou stages", "Examens semestriels"],
            "words_neg":["Pas d'examen par contrôle continu", "Pas d'examen par projets pratiques ou stages", "Pas d'examens semestriels"]
        },
        {
            "id": 5,
            "text": "Avoir autant d'heures qu'au lycée et beaucoup de travail personnel. Ta réaction :",
            "category": "Charge de travail",
            "answers": [
                "Pas de problème ! Je suis prêt(e) à travailler énormément, même si c'est très intense et stressant, pour atteindre un objectif élevé !",
                "Je préfère un rythme soutenu mais qui me laisse quand même le temps de respirer et de bien comprendre sans être sous pression constante.",
                "Je préfère une formation avec beaucoup de temps libre pour m'organiser à ma façon"
            ],
            "scoring": [
                {"cpge": 3, "cmi": 2, "grande_ecole_post_bac": 2, "cupge": 2, "but": 1, "bts": 0, "l1": -2, "deust": -2, "cs": -2, "formations_preparatoires": -1},
                {"l1": 0, "deust": 1, "cs": 2, "formations_preparatoires": 1, "bts": 1, "but": 2, "cpge": -1, "cmi": 2, "grande_ecole_post_bac": 2, "cupge": -0.5},
                {"l1": 3, "deust": 3, "cs": 3, "formations_preparatoires": 2, "bts": -1, "but": 1, "cpge": -3, "cmi": -3, "grande_ecole_post_bac": -2, "cupge": -2}
            ],
            "words_pos":["Intensité forte", "Rythme soutenu", "Rythme léger"],
            "words_neg":["Pas d'intensité forte", "Pas de rythme soutenu qui laisse le temps de respirer", "Pas de rythme léger"]
        },
        {
            "id": 6,
            "text": "L'idée d'essayer d'entrer dans une formation très sélective ?",
            "category": "Sélectivité",
            "answers": [
                "Ça me motive particulièrement,  j'aime les défis et viser des parcours difficiles d'accès.",
                "Je préfère une formation intéressante où j'ai de bonnes chances d'être pris(e) si mon dossier est correct.",
                "Je préfère une formation où il n'y a pas de sélection à l'entrée, je veux éviter le stress et la pression de la compétition."
            ],
            "scoring": [
                {"cpge": 3, "grande_ecole_post_bac": 2, "cmi": 2, "cupge": 2, "but": -2, "bts": -2, "l1" : -2},
                {"bts": 2, "deust": 2, "l1": 1, "cs": 1, "formations_preparatoires": 1, "but": 1, "cpge": -3, "grande_ecole_post_bac": -1, "cmi": -2, "cupge": -2},
                {"bts": 3, "deust": 3, "cs": 3, "formations_preparatoires": 3, "l1": 3, "but": 0, "cmi": -3, "grande_ecole_post_bac": -3, "cpge": -4, "cupge": -4}
            ],
            "words_pos":["Sélection à l'entrée", "Sélection faible à l'entrée", "Pas de sélection à l'entrée"],
            "words_neg":["Pas ou peu de sélection à l'entrée", "Pas de Sélection faible à l'entrée", "Sélection à l'entrée"]
        },
        {
            "id": 7,
            "text": "Qu'est-ce que tu penses d'une ambiance compétitive ?",
            "category": "Ambiance",
            "answers": [
                "Ça me stimule ! La compétition et l'objectif de se classer me poussent à donner le meilleur de moi-même.",
                "Je préfère une ambiance plus basée sur l'entraide et la progression personnelle, où la comparaison constante est moins présente.",
            ],
            "scoring": [
                {"cpge": 3, "cupge": 1, "grande_ecole_post_bac": 1, "cmi": 0, "bts": -2, "but": -1, "l1": -1},
                {"bts": 2, "but": 2, "deust": 2, "l1": 1, "cs": 1, "formations_preparatoires": 1, "cmi": 1, "grande_ecole_post_bac": 0, "cupge": 0, "cpge": -3}
            ],
            "words_pos":["Ambiance compétitive", "Ambiance collaborative"],
            "words_neg":["Pas d'Ambiance compétitive", "Pas d'Ambiance collaborative"]
        },
        {
            "id": 8,
            "text": "Après le bac, tu te vois plutôt parti(e) pour :",
            "category": "Durée & Objectif",
            "answers": [
                "Une formation très courte environ 1 an pour te mettre à niveau ou prendre le temps de mieux choisir ta voie.",
                "Une formation courte environ 2 ans pour apprendre un métier et pouvoir chercher du travail rapidement après.",
                "Une formation où tu peux choisir de continuer les études pour des postes à hautes responsabilités après 3 ans ou travailler directement.",
                "Des études longues (5 ans ou plus) pour devenir vraiment expert(e) dans un domaine et viser des postes à très haute responsabilités"
            ],
            "scoring": [
                {"cs": 1, "formations_preparatoires": 4, "bts": -2, "deust": -2, "but": -3, "l1": -3, "grande_ecole_post_bac": -4, "cmi": -4, "cpge": -4, "cupge": -4},
                {"bts": 3, "deust": 3, "cpge": 0, "cupge": 0,"cs": -2, "formations_preparatoires": -2, "but": -1, "l1": -2, "grande_ecole_post_bac": -3, "cmi": -3},
                {"but": 2, "l1": 4, "cupge": -1, "cpge": -1,"bts": 1, "deust": 1, "cs": -3, "formations_preparatoires": -3, "grande_ecole_post_bac": 1, "cmi": 1},
                {"grande_ecole_post_bac": 4, "cmi": 4, "cpge": 4, "cupge": 4, "l1": 1, "but": -3, "bts": -4, "deust": -4, "cs": -4, "formations_preparatoires": -4}
            ],
            "words_pos":["Formation très courte", "Formation courte", "Possibilité de travailler ou de continuer ses études", "Formation longue"],
            "words_neg":["Formation de plus d'un an", "Formation de plus de 2 ans", "Pas le choix entre travailler et continuer ses études après la formation", "Formation courte"]
        },
        {
            "id": 9,
            "text": "À propos de ton projet professionnel :",
            "category":"Projet professionnel",
            "answers": [
                "Tu penses que tu as le temps, les études c'est (aussi) fait pour découvrir ce qu'on aime.",
                "Tu as déjà une idée assez précise du type de métier ou de secteur qui t'attire.",
                "Tu veux surtout faire les meilleures études possibles, quitte à choisir ta voie plus tard.",
                "Tu sais dans quelle direction aller, le plus important est de choisir une formation avec de bons débouchés."
            ],
            "scoring": [
                {"l1": 2, "but": 1, "grande_ecole_post_bac": 1.5, "cpge": 1, "cupge": 1, "formations_preparatoires": 2, "cmi": -1, "bts": -2, "deust": -2, "cs": -3},
                {"bts": 3, "deust": 3, "cs": 3, "but": 2, "cmi": 1, "grande_ecole_post_bac": 1, "l1": 1, "cpge": 1, "cupge": -1, "formations_preparatoires": -3},
                {"cpge": 3, "cupge": 2, "grande_ecole_post_bac": 2, "cmi": 2, "l1": 1, "but": -1, "formations_preparatoires": -1, "bts": -2, "deust": -2, "cs": -3},
                {"grande_ecole_post_bac": 1,  "cmi": 1, "l1": 1, "cpge": 1, "cupge": 1, "formations_preparatoires": -3}
            ],
            "words_pos":["Temps pour découvrir un domaine qui te plaît", "Formation précise sur un métier ou secteur", "Formation prestigieuse", "Bons débouchés"],
            "words_neg":["Pas de temps pour découvrir un domaine qui te plaît", "Formation trop généraliste", "Formation non prestigieuse", "Débouchés moyens"]
        },
        {
            "id": 10,
            "text": "Quand tu rentres le soir après les cours :",
            "category":"Autonomie & Travail",
            "answers": [
                "Franchement, tu as souvent du mal à te motiver pour faire tes devoirs ou réviser.",
                "Tu as tendance à relire tes notes et à travailler surtout les matières qui t'intéressent le plus.",
                "Tu arrives à travailler un peu ce qui est important et aussi ce qui te plaît, même si ce n'est pas toujours facile.",
                "En général, tu te mets au travail assez facilement pour revoir tes cours et faire ce qu'il y a à faire."
            ],
            "scoring": [
                {"cpge": -2, "cmi": -2, "grande_ecole_post_bac": -1, "cupge": -1, "l1": 0, "but": 1, "bts": 1, "deust": 1, "cs": 1, "formations_preparatoires": 1},
                {"l1": 2, "but": 1, "bts":2, "formations_preparatoires": -1, "grande_ecole_post_bac": -1, "cmi": 1, "cupge": -1, "bts": 1, "deust": 1, "cs": 1, "cpge": -1},
                {"but": 2, "grande_ecole_post_bac": 2, "bts": 1, "deust": 1, "l1": 2, "cmi": 0, "cupge": 2, "cs": 0, "formations_preparatoires": 2, "cpge": 1},
                {"cpge": 3, "cmi": 2, "grande_ecole_post_bac": 2, "cupge": 2, "but": 1, "l1": 2, "bts": -1, "deust": -1, "cs": -1, "formations_preparatoires": -1}
            ],
            "words_pos":["Peu de devoirs et de révisions", "Travaille surtout ce qui intéresse","Travaille l'important et l'intéressant", "Beaucoup de devoirs"],
            "words_neg":["Beaucoup de devoirs", "Devoir dans pas mal de matières différentes", "Beaucoup de travail sur pleins de matières", "Peu de devoirs et de révisions"]
        },
        {
            "id": 11,
            "text": "Quel mot qualifierait le mieux les études idéales pour toi :",
            "category": "Synthèse",
            "answers": [
                "Ambitieuses",
                "Ambiance",
                "Pratiques",
                "Généralistes"
            ],
            "scoring": [
                {"cpge": 3, "grande_ecole_post_bac": 2, "cmi": 1, "cupge": 2, "but": -1, "l1": 0, "formations_preparatoires": -1, "bts": -2, "deust": -2, "cs": -3},
                {"bts": 1, "deust": 1, "but": 1, "cs": 1, "formations_preparatoires": 1, "l1": 1, "grande_ecole_post_bac": 2, "cmi": 0, "cupge": -2, "cpge": -3},
                {"bts": 3, "deust": 3, "cs": 3, "but": 2, "grande_ecole_post_bac": 0, "cmi": -1, "l1": -2, "formations_preparatoires": -2, "cupge": -3, "cpge": -3},
                {"l1": 3, "cpge": 1, "cupge": 1, "but": 0, "grande_ecole_post_bac": 0, "formations_preparatoires": 1, "cmi": -1, "bts": -3, "deust": -3, "cs": -3}
            ],
            "words_pos":["Ambitieux", "Bonne Ambiance","Formation avec de la pratique", "Formation Généraliste"],
            "words_neg":["Peu ambitieux", "Compétitif", "Théorique", "Spécialisé"]
        },
        {
            "id": 12,
            "text": "Quel est le plus important pour toi :",
            "category": "Synthèse",
            "answers": [
                "Salaire",
                "Etudes passionnantes",
                "Etudes courtes",
            ],
            "scoring": [
                {"cpge": 5, "grande_ecole_post_bac": 4, "cmi": 3, "cupge": 5, "but": -1, "l1": 3, "formations_preparatoires": 1, "bts": -3, "deust": -3, "cs": -3},
                {"bts": 0},
                {"bts": 3, "deust": 3, "cs": 3, "but": 2, "grande_ecole_post_bac": -2, "cmi": -2, "l1": -2, "formations_preparatoires": -2, "cupge": -3, "cpge": -3},
            ],
            "words_pos":["Bon Salaire", "Passionnant","études courtes"],
            "words_neg":["Salaire moyen", "Non passionnant", "études longues"]
        }
    ]
  
  // Make sure scoring keys match backend ScoreTypes fields
  // This function converts the keys in the scoring arrays
  const normalizeScoringKeys = (questions) => {
    return questions.map(q => ({
      ...q,
      scoring: q.scoring.map(scoreOption => {
        const normalizedOption = {};
        for (const key in scoreOption) {
          const normalizedKey = FORMATION_KEYS[key] || key.replace(/[\s.]/g, '_').toLowerCase(); // Fallback normalization
          normalizedOption[normalizedKey] = scoreOption[key];
        }
        return normalizedOption;
      })
    }));
  };
  
  
  export const normalizedQuizQuestions = normalizeScoringKeys(quizQuestions);
  
  // Export FORMATION_KEYS if needed elsewhere
  export { FORMATION_KEYS };